import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { sortLayouts } from './sort-layouts.esm.js';
import { keys } from '../constants/keys.esm.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getSelectedLayout } from './get-selected-layout.esm.js';
import { getLayoutType } from './get-layout-type.esm.js';
import { getNewLayoutId } from './get-new-layout-id.esm.js';
import { normalizeLayouts } from './normalize-layouts.esm.js';

var modifyCurrentLayout = function modifyCurrentLayout(resources, lockedFields) {
  return function (layouts, newFields) {
    var newLayouts = normalizeLayouts(resources, lockedFields)(layouts);
    var currentLayout = getSelectedLayout(newLayouts);
    var type = getLayoutType(currentLayout);
    switch (type) {
      //If the user changes the default/predefined layout, we automatically create a new custom layout
      case LayoutType.Default:
      case LayoutType.Predefined:
        {
          var newCustomLayout = {
            fields: newFields,
            id: keys.custom,
            label: resources.custom(),
            selected: true,
            type: LayoutType.Custom
          };
          newLayouts = newLayouts.map(function (layout) {
            if (!layout.selected) {
              return layout;
            }
            return getNewLayoutId(_objectSpread2(_objectSpread2({}, layout), {}, {
              selected: false
            }));
          });
          newLayouts = sortLayouts([newCustomLayout].concat(_toConsumableArray(newLayouts)));
          return newLayouts;
        }
      //For saved/custom layouts, the user can change it
      case LayoutType.Saved:
      case LayoutType.Custom:
        {
          newLayouts = newLayouts.map(function (layout) {
            return layout.selected ? _objectSpread2(_objectSpread2({}, layout), {}, {
              fields: newFields
            }) : layout;
          });
          return newLayouts;
        }
      default:
        return newLayouts;
    }
  };
};

export { modifyCurrentLayout };
//# sourceMappingURL=modify-current-layout.esm.js.map
